export default __webpack_public_path__ + "static/media/sensotrend_dashboard_AGP.8619919d.png";